// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取文件url GET /promotion-resource/file-url */
export async function promotionResourceFileUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionResourceFileUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultURL>('/promotion-resource/file-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取资源文件 GET /promotion-resource/file/info */
export async function promotionResourceFileInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionResourceFileInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionResourceFileResp>('/promotion-resource/file/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 客户领取文件夹url GET /promotion-resource/link-url */
export async function promotionResourceLinkUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionResourceLinkUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/promotion-resource/link-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取文件列表 GET /promotion-resource/list */
export async function promotionResourceListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionResourceListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListPromotionResourceFileResp>('/promotion-resource/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取我的文件夹列表 GET /promotion-resource/my-folder-list */
export async function promotionResourceMyFolderListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListPromotionResourceFolderResp>(
    '/promotion-resource/my-folder-list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
